/**
 * Created by lixinwei on 17/4/19.
 */

// 显示加载
export const SHOW_LOADING = 'SHOW_LOADING';

// 关闭加载
export const HIDE_LOADING = 'HIDE_LOADING';

// 更新用户token
export const UPDATE_TOKEN = 'UPDATE_TOKEN';

// 清空用户token
export const REMOVE_TOKEN = 'REMOVE_TOKEN';

// 切换应用
export const CHANGE_APP = 'CHANGE_APP';



// WEBPACK FOOTER //
// ./src/vuex/types.js